module.exports = "/img/39.7c1c2a.webp";